import $ from 'jquery';
import StringColumn from './StringColumn';
import Globalize from 'globalize';
import moment from 'moment';

export default class DateColumn extends StringColumn {

	displayValue(value) {
		if (value !== null) {
			value = new Date(value);
			if (isNaN(value.getTime())) {
				value = null;
			}
		}
		return this._getFormattedValue(value);
	}

	_getFormattedValue(value) {
		const formatted = Globalize.format(value, this.options.formatString);
		return typeof formatted === 'string' ? formatted.replace(' ', '&nbsp;') : formatted;
	}

	createEditor(value) {
		return $(`<input class="table-input" type="text" data-provider="datepicker" data-vertical="bottom">`).val(value || '').get(0);
	}


	// -------------- FILTERS --------------------

	createFilter() {
		return (
`<div class="input-daterange input-group dtp-date" data-provider="datepicker">
    <input type="text" class="form-control input-sm table-filter" data-vertical="bottom">
    <span class="input-group-addon">-</span>
    <input type="text" class="form-control input-sm table-filter" data-vertical="bottom">
</div>`
		);
	}

	setFilterValue(value) {
		const split = value.split('~', 2);
		const filter = this.column.filter();
		filter.find('input.table-filter:first').val(split[0] || '');
		filter.find('input.table-filter:last').val(split[1] || '');
	}

	buildFilterExpression(fieldName, columnFilter) {
		const fnConvertValue = v => moment(v, ["L LT", "L"]);
		const fnFormatValue = v => fnConvertValue(v).toISOString();
		const fnIsValidFormat = v => /Invalid/.test(fnFormatValue(v)) == false;

		// Currently, we cannot use global search for date and numeric fields (exception on the OData service side)
		// However, individual column filters are supported in form lower~upper
		if (columnFilter.indexOf("~") > -1) {
			const ranges = columnFilter.split("~");
			const rangeQuery = [];

			if (ranges[0] && !fnIsValidFormat(ranges[0]) || 
				ranges[1] && !fnIsValidFormat(ranges[1])) {

				// clear the filter as we have invalid data anyway
				this.column.search("");
				return "";
			}

			if (ranges[0]) {
				rangeQuery.push("(" + fieldName + " ge " + fnFormatValue(ranges[0]) + ")");
			}
			if (ranges[1]) {
				const toDate = this.options.useEndOfDay ? 
								fnConvertValue(ranges[1]).add(1, 'days').subtract(1, 'seconds') : 
								ranges[1];
				rangeQuery.push("(" + fieldName + " le " + fnFormatValue(toDate) + ")");
			}
			return "(" + rangeQuery.join(" and ") + ")";
		} else {
			return "(" + fieldName + " eq " + fnFormatValue(columnFilter) + ")";
		}
	}
}


// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/renderers/DateColumn.js